<template>
	<div class="main">
		<el-image class="frameImg" :src="baseImgUrl + frameImg"></el-image>
	</div>
</template>

<script>
export default {
	name: "Frame",
	data() {
		return {
			baseImgUrl: process.env.VUE_APP_IMGURL,
			frameImg: ''
		}
	},
	mounted() {
		this.$api.get('about/getFrame').then(res => {
			this.frameImg = res.imgEn;
		});
	}
}
</script>

<style scoped>
	.frameImg{ animation: fadeInUp; animation-duration: 2s; }
	@media (max-width: 740px){
		.main{ padding-top: 30px; }
		.frameImg{ margin: 0 auto;  }
	}
	@media (min-width: 740px){
		.main{ padding-top: 30px; }
		.frameImg{ margin: 0 auto; width: 100%; }
	}

</style>